import { Component, OnInit, ViewChild } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { Subscription } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {


  @ViewChild('appSearch') appSearch;
  private routeObs: Subscription;
  routes: any;

  searched: any;
  search: any;

  current: any;
  currentTheme: any;
  older: any;

  constructor(
    public route: RoutingService,
    public api: RestapiService,
    private modalService: NgbModal
  ) {
    this.loadDinamicRoutes();
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      //  console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.setCurrentItem(this.route.current);
      }, 10);
    });
  }

  ngOnInit(): void {
    // this.openNav();
  }

  setCurrentItem(route?) {
    this.older = this.current;
    console.log('set new item', route, this.older);
    this.routes.forEach((v, k) => {
      if ('/' + v.url === route) {
        this.current = k;
        this.currentTheme = v.theme;
        console.log('this.currentTheme ', this.currentTheme);
      }
    });
  }

  loadDinamicRoutes() {
    this.api.getdata('webroute', {
      per_page: 1000,
      // filters: { id: { value: '3,4', operator: 'whereIn' } },
      filters: { type: { value: '1' } , appname: { value: 'educacion' } },
      orderBy: { field: 'id', direction: 'asc' }
    }).subscribe(res => {
      console.log('DINAMIC STATES', res);
      if (res.status === true) {
        this.route.publicRoutes = res.result.data;
        this.routes = res.result.data;
        this.routes.push({
          id: 10,
          state: 'fandelplaneta',
          route: '/fandelplaneta',
          url: 'fandelplaneta',
          theme: 3,
          type: 0,
          image: '/archivos/temp/fp1.png',
          image2: '/archivos/temp/fp1.png',
        })
        this.routes.forEach(r => {
          if (r.state === 'calendario') {
            r.url = "calendario/todos"
          }
          if (r.state === 'centros' || r.state === 'areas protegidas') {
            r.children = r.websection;
            r.open = false;
          }
          if (r.state === 'proyecto en imagenes'/*  || r.state === 'conoce la naturaleza' */) {
            r.children = r.webcontext;
            r.open = false;
          }
          if (r.state === 'recursos didacticos') {
            r.children = r.webcollection;
            r.open = false;
          }
          if (r.state === 'conoce la naturaleza') {
            r.children = r.webcontext;
            r.open = false;
            console.log('new', r.children);
            r.url = 'juego-inicio';
            r.children.forEach(e => {
              /* if (e.id == 12 || e.id == 13) {
                e.name == decodeURI('incendios-forestales');
              } */
              console.log('r.children', e);
            });
            ///juego-inicio/incendios-forestales
          }
        });
        this.setCurrentItem(this.route.current);
      }
      console.log(this.array_move(this.routes, 6, 7));
      console.log('MENU', this.routes, this.routes.length)
    })
  }

  goOutside(url: string){
    window.open(url);
  }
  closeNgo(url: string) {
    this.route.goTo(url);
    this.closeNav()
  }

  openNav() {
    document.getElementById("app-menu").style.left = "0";
    document.body.style.overflow = 'hidden';
  }

  closeNav() {
    document.getElementById("app-menu").style.left = "-100%";
    document.body.style.overflow = 'initial';
  }

  array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };



}
